import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../../theme'

const deviceWidth = Dimensions.get('window').width

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    title: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'center',
        paddingHorizontal: 15,
        paddingTop: 5,
        paddingBottom: 8,
    },
    subtitle: {
        fontSize: 14,
        color: theme.colors.textPrimary,
        fontWeight: 'normal',
        textAlign: 'center',
        paddingHorizontal: 35,
        paddingTop: 5,
        paddingBottom: 8,
    },
    image: {
        width: 120,
        height: 120,
        alignSelf: 'center',
    },
    input: {
        //flexGrow: 0,
        fontSize: 15,
        width: deviceWidth - 30,
        height: 40,
        marginTop: 0,
        marginBottom: 5,
        marginHorizontal: 15,
        borderWidth: 0.2,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        //color: theme.colors.textPrimary,
        padding: 10,
    },
    buttonContainer: {
        flexDirection: 'column',
        width: '100%',
        paddingVertical: 5,
    },
    borderButton: {
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        paddingVertical: 8,
        paddingHorizontal: 50,
        marginHorizontal: 15,
        marginBottom: 15,
        borderRadius: 10,
    },
    borderButtonText: {
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        fontSize: 15,
        textAlign: 'center',
    },
    dividerHorizontalLine: {
        width: '100%',
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        marginVertical: 10,
    },
})

export default styles
